import React, { useState, useContext } from 'react';
import './ReportsList.scss';
import ReportItem from './ReportItem';
import { UpdateReportDialog } from '../../Dialogs/reports';
import { ReportsContext } from '../../../context/reports';

const ReportsList = ({
    reports = [],
    onSelectReport,
    selectedReport,
    intl,
}) => {
    // open menu
    const [openMenu, setOpenMenu] = useState(null);
    const [reportToEdit, setReportToEdit] = useState(null);
    const { getReports } = useContext(ReportsContext);

    return (
        <div className="cg-reports-list">
            {!reports.length && (
                <div className="cg-reports-list__empty">
                    {intl.formatMessage({ id: 'no_reports_found' })}
                </div>
            )}

            {reportToEdit && (
                <UpdateReportDialog
                    reportToEdit={reportToEdit}
                    handleClose={() => setReportToEdit(null)}
                    callback={() => {
                        setReportToEdit(null);
                        getReports();
                    }}
                    intl={intl}
                />
            )}

            {reports.map((report) => (
                <ReportItem
                    report={report}
                    isSelected={selectedReport?.id === report.id}
                    key={report.id}
                    onSelect={() => onSelectReport(report)}
                    intl={intl}
                    menuIsOpen={openMenu === report.id}
                    handleMenu={() => {
                        openMenu === report.id
                            ? setOpenMenu(null)
                            : setOpenMenu(report.id);
                    }}
                    handleReportToEdit={() => setReportToEdit(report)}
                    deleteCallback={getReports}
                />
            ))}
        </div>
    );
};

export default ReportsList;
